import { handleError } from "./errors";

export const get_display_name = (name) => {
    try{
        return name.split('_').join(' ');
    }catch(err){
        console.error(`Error in get_display_name `, err)
        handleError(err);
    }
}